import React, { useEffect, useState, memo, lazy, Suspense } from "react"
import WebHeader from "./WebHeader"
import { useMenuData } from "../../queries/useMenuData"

const MobileHeader = lazy(() => import("./MobileHeader"))

const Header = ({ headerClass }) => {
  const [width, setWidth] = useState()
  const MenuData = useMenuData()
  const { menuItemsList, resMenuItemsList } = MenuData?.wpPage?.MenuPageFields

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => setWidth(window.innerWidth);

    setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [width])

  const breakpoint1200 = 1200;

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {width ? (
        width >= breakpoint1200 ? (
          <WebHeader
            menuItemsList={menuItemsList}
            resMenuItemsList={resMenuItemsList}
            headerClass={headerClass}
            showButton={true}
          />
        ) : (
          <MobileHeader
            menuItemsList={menuItemsList}
            resMenuItemsList={resMenuItemsList}
            headerClass={headerClass}
          />
        )
      ) : (
        //For SEO purpose
        <WebHeader showButton={false} headerClass={`d-none ${headerClass}`} />
      )}
    </Suspense>
  )
}

export default memo(Header)
